import { Injectable } from '@angular/core';
import { CanLoad } from '@angular/router';
import { UrlRedirectService } from '@ddt-web/url';
import { UserDataService, UserProfile } from '@ddt-web/user-data';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class InternalUserGuard implements CanLoad {
	constructor(
		private userDataService: UserDataService,
		private urlRedirectService: UrlRedirectService
	) { }

	public canLoad(): Observable<boolean> {
		return this.userDataService
			.getUserProfile()
			.pipe(
				map((userProfile: UserProfile) => userProfile.internalUser),
				tap(isInternalUser => {
					if (!isInternalUser) {
						this.urlRedirectService.redirectToRoute('/');
					}
				}),
				catchError(() => {
					this.urlRedirectService.redirectToRoute('/');
					return of(false);
				})
			);
	}
}
